import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createI18n } from 'vue-i18n'
import PrimeVue from 'primevue/config'
import 'primevue/resources/themes/aura-dark-amber/theme.css' // Theme
import 'primevue/resources/primevue.min.css' // Core CSS
import 'primeicons/primeicons.css' // Icons
import './assets/main.css'

import hu from './locale/hu.json'
import en from './locale/en.json'

const savedLocale = localStorage.getItem('locale') || 'hu'

const i18n = createI18n({
  legacy: false, 
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: {
    hu: hu,
    en: en
  }
})

const app = createApp(App)
app.use(PrimeVue)
app.use(router)
app.use(i18n)
app.mount('#app')

